import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { initSentry, sendBootHeartbeat } from './lib/sentry';

// Phase 11: admin.cafefinder.click 전용 entry. 메인 번들은 `@toss/tds-mobile` ThemeProvider를
// 거치는데, 해당 패키지가 AppsInToss 런타임 외 환경에서 로드 시 예외를 던져 화이트 스크린을
// 유발한다. 어드민 화면은 로컬 TDS 토큰(constants/tds.ts)과 로컬 래퍼만 사용하므로
// ThemeProvider를 생략한 별도 entry로 분리해 일반 브라우저에서 동작시킨다.

initSentry();
sendBootHeartbeat();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in DOM');
}

function AdminRoutes() {
  return (
    <Routes>
      {/* 관리자 경로 */}
      <Route path="/admin" element={<AdminLoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      {/* 그 외 진입은 로그인으로 보냄 */}
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <AdminRoutes />
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>
);
